import type { FC } from 'react'

import { LoaderCircle } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { useTranslation } from '@/app/translations/translations-hooks'
import { LoadingError } from '@/components/LoadingError'
import queries from '@/modules/admin/queries'
import adminResources from '@/modules/admin/resources'

import { DevicePolicyOrigin } from './DevicePolicyOrigin'
import { EcomPolicyOrigin } from './EcomPolicyOrigin'
import { Edits } from './Edits'
import { SalaryDeductions } from './SalaryDeductions'

export const AssetOrigin: FC = () => {
  const params = useParams()
  const assetId = Number(params.id)
  const translate = useTranslation()

  if (isNaN(assetId)) throw Error(translate('Asset ID is not a number!'))

  const { data: assetDetails, isError } = useQuery(queries.adminAsset(assetId), () =>
    adminResources.getAsset(assetId)
  )

  if (isError) {
    return <LoadingError />
  }

  if (!assetDetails) {
    return (
      <div>
        <LoaderCircle />
      </div>
    )
  }

  return (
    <div className="-mx-2 -my-4 flex flex-wrap">
      <Edits assetDetails={assetDetails} />
      <DevicePolicyOrigin assetDetails={assetDetails} />
      <EcomPolicyOrigin assetDetails={assetDetails} />
      <SalaryDeductions assetDetails={assetDetails} />
    </div>
  )
}
